import { useLocation } from 'react-router-dom';
import { notification } from 'antd';
import MESSAGES from '../../enums/Messages';

export function IsLoggedIn() {
  return window.localStorage['access_token'] !== undefined;
}

export function setUserSession(session_data) {
  let user_data = session_data.attributes;
  window.localStorage['access_token'] = session_data.token;
  window.localStorage['userId'] = user_data.id;
  window.localStorage['tercero'] = session_data.resume;
  window.localStorage['username'] = user_data.username;
  window.localStorage['email'] = user_data.email;
  window.localStorage['first_name'] = user_data.first_name;
  window.localStorage['last_name'] = user_data.last_name;
  window.localStorage['last_login'] = user_data.last_login;
  window.localStorage['person_type'] = session_data.person_type;
  window.localStorage['group'] = user_data.group;
  window.localStorage['role'] = user_data.role;
  window.localStorage['permissions'] = JSON.stringify(session_data.permissions);
  window.localStorage['gp_permissions'] = JSON.stringify(
    session_data.gp_permissions,
  );
  window.location.reload();
}

export function getLocalStorage(attrName, allowUndefined = false) {
  const res = window.localStorage[attrName];
  if (!allowUndefined && res === undefined) {
    console.error(attrName);
    LogOut();
  }
  return res;
}

export function getPermissions() {
  try {
    const perms = JSON.parse(window.localStorage['permissions']);
    return {
      id: getLocalStorage('group'),
      nombre: getLocalStorage('role'),
      ...perms.lista_permisos.reduce((map, value) => {
        map[value.descripcion] = perms.tipo_permisos.reduce(
          (perm_map, type) => {
            perm_map[type.tipo] = value.tipos.includes(type.id);
            return perm_map;
          },
          {},
        );
        return map;
      }, {}),
    };
  } catch (error) {
    console.log(error);
    LogOut();
  }
}

export function LogOut() {
  window.localStorage.clear();
  window.location = '/';
}

export const IsRole = (rol) => {
  const group = getLocalStorage('group');
  return parseInt(group) === rol;
};
export const useQuery = () => new URLSearchParams(useLocation().search);

export const useParsedSearch = (schema = {}) => {
  const params = useQuery();
  const result = {};
  for (const key in schema) {
    const rawValue = params.get(key);

    if (rawValue === null) {
      result[key] = null;
      continue;
    }
    const transform = schema[key];
    if (typeof transform === 'function') {
      result[key] = transform(rawValue);
    } else if (transform === 'int') {
      const parsed = parseInt(rawValue, 10);
      result[key] = isNaN(parsed) ? null : parsed;
    } else if (transform === 'string') {
      result[key] = rawValue;
    } else if (Array.isArray(transform)) {
      result[key] = transform.includes(rawValue) ? rawValue : null;
    } else {
      // fallback if unknown type
      result[key] = rawValue;
    }
  }
  return result;
};

export const DateFormat = (date) => {
  if (date) {
    let format = new Date(date).toISOString().split('T')[0];
    return format;
  }
};

export const validateFileType = (file, accept) => {
  if (!accept) return true;

  const mime = file.type;
  const acceptItems = accept.split(',').map((s) => s.trim().toLowerCase());

  return acceptItems.some((rule) => {
    if (rule === mime) return true;

    if (rule.endsWith('/*')) {
      // e.g. rule = "image/*"
      const typeGroup = rule.split('/')[0];
      return mime.startsWith(typeGroup + '/');
    }

    if (rule.startsWith('.')) {
      // e.g. ".pdf", ".jpg"
      return file.name?.toLowerCase().endsWith(rule);
    }

    // fallback for extension comparison (non-standard)
    if (rule.includes('/')) return mime === rule;

    return false;
  });
};

export const validatorNumbers = (minLength = 0, zeroPass = false) => {
  return () => ({
    validator(_, value) {
      if (new RegExp('^[0-9]*$').test(value)) {
        if (
          !value ||
          minLength === 0 ||
          value.toString().length >= minLength ||
          (zeroPass && value.toString() === '0')
        ) {
          return Promise.resolve();
        } else
          return Promise.reject(
            new Error(`Ingrese mínimo ${minLength} números`),
          );
      }
      return Promise.reject(new Error(`Ingrese únicamente números`));
    },
  });
};

export const removeExcelIllegalChars = (value) => {
  if (!value) return '';
  return value.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F]/g, '');
};

export const catchException = (
  exception,
  message = MESSAGES.DESC_ERROR_GET_MSG,
  seconds = MESSAGES.TIME_SECONDS,
  props = {},
  sRate = undefined,
) => {
  console.log(exception);

  if (exception?.response?.data?.errors) {
    const errors = exception.response.data.errors;
    message = errors.map((ei) => ei.detail).join(' - ');
  }

  notification.error({
    message: MESSAGES.ERROR_MSG,
    description: message,
    duration: sRate
      ? Math.max(message.length * sRate, MESSAGES.TIME_SECONDS)
      : seconds,
    ...props,
  });
  return message;
};

export const catchExceptionSRate = (
  exception,
  message = MESSAGES.DESC_ERROR_GET_MSG,
  rate = 0.05,
) => {
  return catchException(exception, message, 0, {}, rate);
};

export const makeFilterParams = (
  params = {},
  page = undefined,
  pageSize = 10,
  search = false,
  sortBy = undefined,
  exportCSV = false,
) => {
  const filterParams = Object.entries(params).reduce((pv, cv) => {
    pv[`filter[${cv[0]}]`] = cv[1] !== '' ? cv[1] : null;
    return pv;
  }, {});
  return {
    params: {
      ...filterParams,
      ...(page ? { 'page[number]': page, 'page[size]': pageSize } : {}),
      ...(search ? { 'filter[search]': search } : {}),
      ...(sortBy ? { sort: sortBy } : {}),
    },
    ...(exportCSV ? { responseType: 'blob' } : {}),
  };
};

export function delayedPromise(delay) {
  // For testing & debugging
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve('Promise resolved!');
    }, delay);
  });
}
